import Backdrop from "@material-ui/core/Backdrop";
import Box from "@material-ui/core/Box";
import Modal from "@material-ui/core/Modal";
import Fade from "@material-ui/core/Fade";
import Typography from "@material-ui/core/Typography";
import { useSelector } from "react-redux";
import Grid from "@material-ui/core/Grid";
import { Autocomplete } from "@material-ui/lab";
import TextField from "@material-ui/core/TextField";
import useCustomState from "../../hooks/State";
import { useEffect } from "react";
import Button from "@material-ui/core/Button";
import Call from "../../service/API";
import { ERROR_COLOR, GREEN_PRIMRY, WHITE } from "../../utils/const";
import Swal from "sweetalert2";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  //   border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const EditCounterModal = (props) => {
  const handleClose = () => {
    props.open.handleChange(false);
  };

  const counterTypes = useSelector((state) => state.counterTypes);

  const types = useCustomState([]);
  const selectedType = useCustomState({ title: "", id: -1 });
  const typeError = useCustomState({ error: false, text: "" });

  const counterName = useCustomState("");
  const counterNameError = useCustomState({ error: false, text: "" });
  const counterLocation = useCustomState("");
  const billFactor = useCustomState(1);
  const counterManualNumber = useCustomState(0);
  // const counterManualNumberError
  const counterManualNumberChanged = (e) => {
    counterManualNumber.handleChange(e.target.value);
  };
  const billFactorChanged = (e) => {
    billFactor.handleChange(e.target.value);
  };
  const counterLocationChanged = (e) => {
    counterLocation.handleChange(e.target.value);
  };
  const counterNameChanged = (e) => {
    counterNameError.handleChange({ error: false, text: "" });
    counterName.handleChange(e.target.value);
  };
  useEffect(() => {
    const ts = [];
    let data;
    counterTypes.map((type) => {
      data = {
        title: type.water_meter_type_name,
        id: type.water_meter_type_id,
        category: type.water_meter_tag.water_meter_tag_name,
      };
      ts.push(data);
    });
    types.handleChange(ts);
    counterName.handleChange(props.counter.water_meter_name);
    counterLocation.handleChange(props.counter.water_meter_location);
    counterManualNumber.handleChange(props.counter.water_meter_manual_number);
    const factor = props.counter.other_information?.bill_factor
      ? props.counter.other_information?.bill_factor
      : 1;
    billFactor.handleChange(factor);
  }, []);

  const typeChanged = (e, newValue) => {
    typeError.handleChange({ error: false, text: "" });
    selectedType.handleChange(newValue);
  };

  const editCounter = (e) => {
    let hasError;
    const name = counterName.value;
    const manualNumber = counterManualNumber.value;
    const location = counterLocation.value;
    const factorOfBill = billFactor.value;
    if (name.length === 0) {
      counterNameError.handleChange({
        error: true,
        text: "واردکردن نام کنتور الزامی است.",
      });
      hasError = true;
    }
    if (hasError) {
      return;
    }
    const moduleId = props.counter.water_meter_module_info.water_meter_module_id
      ? props.counter.water_meter_module_info.water_meter_module_id
      : null;
    const projectId = props.counter.water_meter_project_info.project_id
      ? props.counter.water_meter_project_info.project_id
      : null;
    const userId = props.counter.water_meter_user_info.user_id
      ? props.counter.water_meter_user_info.user_id
      : null;
    const data = {
      water_meter_serial: props.counter.water_meter_serial,
      water_meter_name: name,
      water_meter_location: location,
      other_information: {
        ...props.counter.other_information,
        bill_factor: factorOfBill,
      },
      water_meter_validation: props.counter.water_meter_validation,
      water_meter_activation: props.counter.water_meter_activation,
      water_meter_condition: props.counter.water_meter_condition,
      water_meter_module_id: moduleId,
      water_meter_project_id: projectId,
      water_meter_user_id: userId,
      water_meter_manual_number: Number(manualNumber),
    };

    // console.log(data);
    Call("POST", "watermeters/admin/edit", data)
      .then((response) => {
        // console.log("edit counter info: ", response);
        if (response.data.code == 200) {
          let new_counterInfo = { ...props.counterInfo.value };
          //posible err in here console.log(counterInfo.value[0])
          new_counterInfo.water_meter_manual_number = Number(manualNumber);
          props.altCounter(new_counterInfo);
          handleClose();
          Swal.fire({
            toast: true,
            title: "تغییرات با موفقیت اعمال شد",
            color: WHITE,
            timer: 4000,
            position: "bottom-start",
            icon: "success",
            showConfirmButton: false,
            timerProgressBar: true,
            background: GREEN_PRIMRY,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          const data = error.response.data;
          Swal.fire({
            toast: true,
            title: "در اعمال تغییرات مشکلی رخ داده",
            color: WHITE,
            timer: 4000,
            position: "bottom-start",
            icon: "error",
            showConfirmButton: false,
            timerProgressBar: true,
            background: ERROR_COLOR,
          });
        }
      });
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={props.open.value}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={props.open.value}>
        <Box sx={style} style={{ borderRadius: "8px" }}>
          <Typography id="transition-modal-title" variant="h6" component="h2">
            ویرایش اطلاعات کنتور
          </Typography>
          <Grid
            style={{ marginTop: "24px" }}
            container
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <TextField
                onChange={counterNameChanged}
                error={counterNameError.value.error}
                helperText={counterNameError.value.text}
                value={counterName.value}
                fullWidth
                label="نام کنتور"
                variant="standard"
              />
              <TextField
                onChange={counterManualNumberChanged}
                // helperText={counterManualNumber.value}
                value={counterManualNumber.value}
                fullWidth
                label="عدد کنتور"
                variant="standard"
              />
              <TextField
                onChange={billFactorChanged}
                value={billFactor.value}
                fullWidth
                label="ضریب مصرف کنتور"
                variant="standard"
              />
              <TextField
                onChange={counterLocationChanged}
                value={counterLocation.value}
                fullWidth
                label="آدرس کنتور"
                variant="standard"
              />
            </Grid>
            <Grid
              style={{ marginTop: "48px" }}
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
            >
              <Button
                onClick={editCounter}
                style={{ color: "#fff" }}
                variant="contained"
                color="primary"
              >
                ویرایش
              </Button>
              <Button
                onClick={handleClose}
                style={{
                  color: "#fff",
                  marginRight: "4px",
                  backgroundColor: ERROR_COLOR,
                }}
                variant="contained"
              >
                انصراف
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Fade>
    </Modal>
  );
};

export default EditCounterModal;
